import { keysSelectedToSum } from "../utils";

const state = {
  selectedNote: {},
  selectedSped: {},
  selectedDataOnSped: {},
  allSelectedDataOnNfe: [],
  isMovIcms: false,
  showAccountsGrid: false,
  didChangeCta: {},
  cfopList: [],
  favoriteAccounts: [],
  lastNoteOpen: { sped: [], nfe: [] },
  keysSelectedToSum,
  selectedKeysToShowSped: [],
  selectedKeysToShowNfe: [],
  selectedNoteVlIcmsClient: 0,
  viewOnlyMode: false,
};

export default state;
